export const IOS_WEBCLIP_SOURCE_QUERY_KEY = "source";
export const IOS_WEBCLIP_SHELL = "ios-webclip";
export const IOS_WEBCLIP_SESSION_KEY = "apk-games:ios-webclip";

const LOOPBACK_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "[::1]",
  "::1",
]);

type CapacitorRuntime = {
  getPlatform?: () => string;
  isNativePlatform?: () => boolean;
};

type NativeRuntimeGlobal = typeof globalThis & {
  Capacitor?: CapacitorRuntime;
  GGEndpointBridge?: { openPortalInWebView?: (url: string) => void };
  androidBridge?: { postMessage?: (data: string) => void };
  webkit?: { messageHandlers?: { bridge?: unknown } };
};

export function isNativeGameWebView() {
  if (typeof globalThis === "undefined") return false;

  const runtimeGlobal = globalThis as NativeRuntimeGlobal;
  const capacitor = runtimeGlobal.Capacitor;
  if (
    typeof capacitor?.isNativePlatform === "function" &&
    capacitor.isNativePlatform()
  ) {
    return true;
  }
  if (
    typeof capacitor?.getPlatform === "function" &&
    capacitor.getPlatform() !== "web"
  ) {
    return true;
  }

  return Boolean(
    runtimeGlobal.GGEndpointBridge?.openPortalInWebView ||
      runtimeGlobal.androidBridge?.postMessage ||
      runtimeGlobal.webkit?.messageHandlers?.bridge,
  );
}

/**
 * 描述文件入口会携带 source；同一 Web Clip 会话内缓存标识，避免游戏内部路由清理查询参数后退化成普通浏览器跳转。
 */
export function isIosWebClip() {
  if (typeof window === "undefined") return false;

  try {
    const source = new URL(window.location.href).searchParams.get(
      IOS_WEBCLIP_SOURCE_QUERY_KEY,
    );
    if (source === IOS_WEBCLIP_SHELL) {
      window.sessionStorage.setItem(IOS_WEBCLIP_SESSION_KEY, IOS_WEBCLIP_SHELL);
      return true;
    }
    return (
      window.sessionStorage.getItem(IOS_WEBCLIP_SESSION_KEY) ===
      IOS_WEBCLIP_SHELL
    );
  } catch {
    try {
      return (
        new URL(window.location.href).searchParams.get(
          IOS_WEBCLIP_SOURCE_QUERY_KEY,
        ) === IOS_WEBCLIP_SHELL
      );
    } catch {
      return false;
    }
  }
}

/**
 * 线上浏览器 H5 与当前站点同源请求 API，不参与线路发现或故障切域。
 * loopback（本地开发和 Capacitor）以及 iOS Web Clip 返回 undefined，继续使用动态线路池。
 */
export function getDirectWebRuntimeOrigin() {
  if (
    typeof window === "undefined" ||
    isNativeGameWebView() ||
    isIosWebClip()
  ) {
    return undefined;
  }

  try {
    const currentUrl = new URL(window.location.href);
    if (
      (currentUrl.protocol !== "http:" && currentUrl.protocol !== "https:") ||
      LOOPBACK_HOSTS.has(currentUrl.hostname)
    ) {
      return undefined;
    }
    return currentUrl.origin;
  } catch {
    return undefined;
  }
}
